module.exports = __webpack_public_path__ + "src/img/default.dd67df1c.png";